<script setup>
import { headingText } from '~/composables/headingText'

defineProps(['model'])
</script>

<template>
  <div
    v-if="model.variation?.value == null || model.variation?.value === 0"
    class="feature-column-block block-spacing"
  >
    <div class="container-fluid">
      <div class="feature-column-block__wrap grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[70px] lg:gap-[80px]">
        <div
          v-for="card in model.columns?.expandedValue"
          :key="card.name?.value"
          class="feature-column-block__card prose flex flex-col"
        >
          <div class="flex justify-center">
            <NuxtImg
              v-if="card.aprimoImage?.url"
              provider="fastlyAprimo"
              :src="card.aprimoImage.url"
              :alt="card.imageAltText?.value ? card.imageAltText?.value : card.aprimoImage.altText"
              loading="lazy"
              class="rounded-xl w-full aspect-[347/209] object-contain"
              :width="card.aprimoImage.width ?? 347"
              fit="bounds"
              sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 347px"
            />
          </div>
          <div class="feature-column-block__card-text">
            <h2
              v-if="headingText(card.title)"
              class="h3 mt-0"
            >
              <ULink
                :to="useCmsUrl(card.linkInternal?.expandedValue?.url ? card.linkInternal?.expandedValue?.url : card.linkExternal?.value ?? '')"
                :locale="false"
                class="decoration-med-aqua underline-offset-8"
              >
                {{ headingText(card.title) }}
              </ULink>
            </h2>
            <div
              v-html="card.body?.value"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    v-else-if="model.variation?.value === 1"
    class="feature-column-block block-spacing"
  >
    <div class="container-fluid">
      <div class="feature-column-block__wrap grid grid-cols-1 lg:grid-cols-3 gap-[70px] lg:gap-[80px]">
        <div
          v-for="card in model.columns?.expandedValue"
          :key="card.name?.value"
          class="feature-column-block__card prose flex flex-col"
        >
          <NuxtImg
            v-if="card.aprimoImage?.url"
            provider="fastlyAprimo"
            :src="card.aprimoImage.url"
            :alt="card.imageAltText?.value ? card.imageAltText?.value : card.aprimoImage.altText"
            loading="lazy"
            class="rounded-xl w-full aspect-[347/209] object-contain"
            :width="card.aprimoImage.width ?? 347"
            sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 347px"
          />
          <div class="feature-column-block__card-text">
            <h2
              v-if="headingText(card.title)"
              class="h3 mt-0"
            >
              {{ headingText(card.title) }}
            </h2>
            <div
              v-html="card.body?.value"
            />
          </div>
          <UButton
            v-if="card.buttonText?.value"
            :to="useCmsUrl(card.linkInternal?.expandedValue?.url ? card.linkInternal?.expandedValue?.url : card.linkExternal?.value ?? '')"
            :locale="false"
            color="info"
            variant="solid"
            class="w-3/4 sm:w-auto self-center sm:self-start"
          >
            {{ card.buttonText?.value }}
          </UButton>
        </div>
      </div>
    </div>
  </div>

  <div
    v-else-if="model.variation?.value === 2"
    class="feature-column-block block-spacing"
  >
    <div class="container-fluid">
      <div class="feature-column-block__wrap grid grid-cols-1 lg:grid-cols-3 gap-[70px] lg:gap-[80px]">
        <div
          v-for="card in model.columns?.expandedValue"
          :key="card.name?.value"
          class="feature-column-block__card prose flex flex-col"
        >
          <NuxtImg
            v-if="card.aprimoImage?.url"
            provider="fastlyAprimo"
            :src="card.aprimoImage.url"
            :alt="card.imageAltText?.value ? card.imageAltText?.value : card.aprimoImage.altText"
            loading="lazy"
            class="rounded-xl w-full aspect-[347/209] object-contain"
            :width="card.aprimoImage.width ?? 347"
            sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 347px"
          />
          <div class="feature-column-block__card-text">
            <h2
              v-if="headingText(card.title)"
              class="h3 mt-0"
            >
              {{ headingText(card.title) }}
            </h2>
            <div
              v-html="card.body?.value"
            />
          </div>
          <UButton
            v-if="card.buttonText?.value"
            :to="useCmsUrl(card.linkInternal?.expandedValue?.url ? card.linkInternal?.expandedValue?.url : card.linkExternal?.value ?? '')"
            :locale="false"
            color="primary"
            variant="solid"
            class="w-3/4 sm:w-auto self-center sm:self-start"
          >
            {{ card.buttonText?.value }}
          </UButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/blocks/feature-column-block.scss';
</style>
